<template>
  <v-dialog
    v-model="agregarEstudiosDialog"
    width="50%"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        rounded
        small
        color="secondary"
        class="d-inline ml-4"
        v-bind="attrs"
        v-on="on"
        @click="agregarEstudiosDialog = true"
      >
        Agregar estudios
      </v-btn>
    </template>
    <v-card
      color="primary"
      tile
    >
      <v-card-title>
        <div class="text-h6">
          Nuevo estudio
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="agregarEstudiosDialog = false"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="studiesForm"
        >
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="institucion"
                  rounded
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Institución"
                  :rules="nameRules"
                />
              </v-col>
              <!-- <v-col cols="4">
                                <v-text-field
                                    v-model="generacionInicio"
                                    maxlength="4"
                                    rounded
                                    filled
                                    dense
                                    background-color="primary"
                                    color="secondary"
                                    label="Año de inicio"
                                    :rules="nameRules"
                                ></v-text-field>
                            </v-col> -->
              <v-col cols="4">
                <v-text-field
                  v-model="generacionFin"
                  maxlength="4"
                  rounded
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Año de finalización"
                  :rules="nameRules"
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="estatusEstudiosElegido"
                  label="Estatus de estudios"
                  background-color="primary"
                  color="secondary"
                  rounded
                  filled
                  dense
                  :items="estatusEstudios"
                  item-value="id"
                  item-text="title"
                  :rules="nameRules"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="observaciones"
                  no-resize
                  rows="4"
                  color="secondary"
                  background-color="primary"
                  label="Observaciones (Opcional)"
                  rounded
                  filled
                  dense
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="tipoEstudioElegido"
                  label="Tipo de estudios"
                  background-color="primary"
                  color="secondary"
                  rounded
                  filled
                  dense
                  :items="tipoEstudios"
                  item-value="id"
                  item-text="title"
                  :rules="nameRules"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="comprobanteEstudioElegido"
                  label="Tipo de comprobante de estudios"
                  background-color="primary"
                  color="secondary"
                  rounded
                  filled
                  dense
                  :items="comprobanteEstudios"
                  item-value="id"
                  item-text="title"
                  :rules="nameRules"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          rounded
          color="secondary"
          :disabled="!studiesForm || loading"
          @click="triggerSaveStudies()"
        >
          Guardar estudios
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    idPersonal: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      agregarEstudiosDialog: false,

      studiesForm: false,
      loading: false,
      estatusEstudio: null,
      institucion: '',
      generacionInicio: '',
      generacionFin: '',
      observaciones: '',
      comprobanteEstudioElegido: null,
      tipoEstudioElegido: null,
      estatusEstudiosElegido: null,
      nameRules: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  computed: {
    ...mapGetters('comprobanteEstudios', {
      comprobanteEstudios: 'getComprobantesEstudios',
    }),
    ...mapGetters('estatusEstudios', {
      estatusEstudios: 'getEstatusEstudios',
    }),

    ...mapGetters('estudio', {
      tipoEstudios: 'getTipoEstudios',
    }),
  },

  async mounted() {
    await this.fetchComprobantesEstudios();
    await this.fetchEstatusEstudios();
    await this.fetchTipoEstudios();
  },

  methods: {
    ...mapActions('estudio', ['saveEstudiosPersonal', 'fetchEstudiosByPersonal', 'fetchTipoEstudios']),
    ...mapActions('comprobanteEstudios', ['fetchComprobantesEstudios']),
    ...mapActions('estatusEstudios', ['fetchEstatusEstudios']),

    async triggerSaveStudies() {
      this.loading = true;

      await this.saveEstudiosPersonal({
        fk_idPersonal: this.idPersonal,
        institucion: this.institucion,
        generacion: this.generacionFin,
        observaciones: this.observaciones,
        fk_idCatEstatusEstudio: this.estatusEstudiosElegido,
        fk_idCatEstudio: this.tipoEstudioElegido,
        fk_idComprobanteEstudio: this.comprobanteEstudioElegido,
      });

      await this.fetchEstudiosByPersonal(this.idPersonal);
      this.closeDialog();
    },

    closeDialog() {
      this.estatusEstudio = null;
      this.institucion = '';
      this.generacionInicio = '';
      this.generacionFin = '';
      this.observaciones = '';
      this.comprobanteEstudioElegido = null;
      this.tipoEstudioElegido = null;
      this.estatusEstudiosElegido = null;
      this.$refs.form.resetValidation();
      this.loading = false;
      this.agregarEstudiosDialog = false;
    },
  },
};
</script>
